module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "polidog"
  }, [_c('div', {
    staticClass: "right"
  }, [(_vm.flagState.right === 1) ? _c('img', {
    attrs: {
      "src": require("../../static/img/polidog_flag_raise_right.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../static/img/polidog_flag_right.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [(_vm.flagState.left === 1) ? _c('img', {
    attrs: {
      "src": require("../../static/img/polidog_flag_raise_left.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../static/img/polidog_flag_left.png")
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a4b63e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Polidog.vue
// module id = 27
// module chunks = 0